import { gql } from "@apollo/client";

export const GET_ALL_DESIGNS = gql`
  query designs(
    $pagination: PaginationInput
    $filter: FilterInput
    $sort: SortInput
  ) {
    designs(pagination: $pagination, filter: $filter, sort: $sort) {
      pagination {
        page
        limit
        total
      }
      designs {
        _id
        name
        design
        description
        images
        price
        featuredImage
        marketPlaceType
        ownerId
        comments
        commentCount
        totalLikes
        totalDisLikes
        printCount
        downloadsCount
        active
        owner {
          _id
          firstName
          lastName
          totalLikes
          likedBy
        }
        likedBy
        disLikedBy
      }
    }
  }
`;
export const GET_SINGLE_DESIGN = gql`
  query design($designId: ID!) {
    design(designId: $designId) {
      _id
      name
      design
      description
      images
      active
      price
      featuredImage
      marketPlaceType
      ownerId
      comments
      commentCount
      printCount
      downloadsCount
      totalLikes
      totalDisLikes
      owner {
        _id
        firstName
      }
      likedBy
      disLikedBy
    }
  }
`;
export const MY_DESIGNS = gql`
  query myDesigns($pagination: PaginationInput!) {
    myDesigns(pagination: $pagination) {
      pagination {
        page
        limit
      }
      designs {
        _id
        name
        design
        description
        images
        active
        featuredImage
        marketPlaceType
        otherDesigns
        ownerId
        comments
        commentCount
        printCount
        downloadsCount
        totalLikes
        totalDisLikes
        active
        owner {
          _id
          firstName
          role
          likedBy
        }
        likedBy
        disLikedBy
      }
    }
  }
`;
